function FormataMoeda(valor: number | undefined): string {
    return Number(valor || '')?.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}) || '';
}

export default FormataMoeda;